import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 登入页账号登入
 *
 * @param {Object} data 手机号密码等
 *
 * @returns {Promise<any>}
 */
$api.loginPassword = function(data) {
	const url = 'login-password';
	const promise = new Promise(function(resolve, reject){
		$http.post(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	} else {
		  		reject(response);
		  	}
		});
	});
  	return promise;
}

/**
 * 是否弹出图片验证码
 * 
 * @param {Object} data 含有手机号
 *
 * @returns {Promise<any>}
 */
$api.isVerify = function(data) {
	const url = 'is-verify';
	const promise = new Promise(function(resolve, reject){
		$http.get(url, {params: data}).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve();
		  	}else{
				reject();
		  	}
		});
	});
  	return promise;
}

/**
 * 登入页短信登入
 * 
 * @param {Object} data 含有手机号、短信验证码、图形验证码（可选）
 *
 * @returns {Promise<any>}
 */
$api.loginVerify = function(data) {
	const url = 'login-verify';
	const promise = new Promise(function(resolve, reject){
		$http.post(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	} else {
		  		reject(response);
		  	}
		});
	});
  	return promise;
}

/**
 * 登入页微信登入
 *
 * @returns {Promise<any>}
 */
$api.wechatLogin = function() {
	const url = 'wechat-login';
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	} else {
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 登入页微信登入
 *
 * @param data
 *
 * @returns {Promise<any>}
 */
$api.wechatLoginValidate = function(data) {
	const url = 'wechat-login-validate';
	const promise = new Promise(function(resolve, reject){
		$http.post(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	} else {
		  		utils.notice(response.msg, 'error');
		  		reject();
		  	}
		});
	});
  	return promise;
}

/**
 * 微信账号绑定
 *
 * @param {Object} data 微信必要参数，包含code,state
 *
 * @date 2019-1-15
 *
 * @returns {Promise<any>}
 */
$api.wechatBind = (data)=>{
	const url = "wechat-binding";
    const promise = new Promise(function(resolve, reject){
        $http.put(url, data).then(function (response) {
            if (response.code == 200) {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
                reject();
            }
        });
    });
    return promise;
};

export default $api; 


// WEBPACK FOOTER //
// ./src/service/login/index.js